import { PrintArea, ProductPrintColorConfiguration } from '@data/sanity/schema'
import { SanityComplexPortableText, SanitySimplePortableText } from './content'
import { SanityImageFragment } from './image'
import { SanityPrintColor } from './shop'

export type SanityPrintSlotType = 'front' | 'back'

export type SanityPrintType = 'logo' | 'image' | 'text'

export interface SanityPrintSlot {
  _id: string
  type: SanityPrintSlotType
  name: string
  description?: SanitySimplePortableText
}

interface SanityProductGalleryPhoto {
  forOption: string
  photos: SanityImageFragment[]
}

interface SanityPrintSlotSettingsProduct {
  galleryPhotos?: SanityProductGalleryPhoto[]
  printConfiguration?: SanityProductPrintConfiguration[]
}

interface SanityPrintSlotSettingsProductVariantOption {
  name: string
  position: number
  value: string
}

interface SanityPrintSlotSettingsProductVariant {
  options: SanityPrintSlotSettingsProductVariantOption[]
  product: SanityPrintSlotSettingsProduct | null
  printPermissionSettings: SanityPrintPermissionSettings | null
}

export interface SanityPrintSlotSettings {
  _id: string
  type: SanityPrintSlotType
  name: string
  description?: SanityComplexPortableText
  previewProductVariant: SanityPrintSlotSettingsProductVariant | null
  previewAreaColor?: SanityPrintColor
}

export interface SanityPrintPermission {
  _key: string
  slot: SanityPrintSlot
  logo: boolean
  image: boolean
  text: boolean
  separateLogoImage: boolean
}

export interface SanityPrintPermissionSettings {
  printPermissions: SanityPrintPermission[]
}

export enum SanityPrintAreaType {
  LOGO = 'logo',
  IMAGE = 'image',
  TEXT = 'text',
}

export type SanityPrintArea = Pick<
  PrintArea,
  'x' | 'y' | 'width' | 'height'
> & {
  type: SanityPrintAreaType
}

export type SanityProductPrintColorConfiguration = Pick<
  ProductPrintColorConfiguration,
  'isMaster' | 'isInheritedFromMaster' | 'galleryItem' | 'galleryPhoto'
> & {
  printAreas?: SanityPrintArea[]
}

export interface SanityProductPrintConfiguration {
  slot: SanityPrintSlot
  colorConfiguration: SanityProductPrintColorConfiguration[]
}

interface SanityPrintFeeProductVariant {
  id: number
  title: string
  price?: number
  comparePrice?: number
}

export interface SanityPrintFeeCombinationItem {
  slot: SanityPrintSlot
  type: SanityPrintType
  productVariant: SanityPrintFeeProductVariant
}

export interface SanityPrintFeeCombination {
  printFeeCombinationItems: SanityPrintFeeCombinationItem[]
}

export interface SanityPrintFeeSettings {
  printFeeCombinations: SanityPrintFeeCombination[]
}
